export default __webpack_public_path__ + "static/media/promo_05.d64d6a22.jpg";